import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "store/hooks";
import { getTestTypeValue } from "store/slices/test";
import { getTestTypeLocaleKey } from "utils/testType.utils";
import { useTheme } from "@mui/material/styles";
import AttentionIcon from "assets/Icons/attention.svg?react";

import YouTube from "react-youtube";
import MDButton from "components/MDButton";

import { makeStyles } from "tss-react/mui";
import { styles } from "./InstractionsScreen.styles";
import { sentryLogMessage } from "services/sentryLogger";
import { SENTRY_EVENT_TYPES } from "constants/sentryEvents";
import classNames from "classnames";
import { HMO } from "constants/hmo";
import { detectHmo } from "utils/hmoDetection";

interface StepProps {
  handleUpdateStep: (step: number) => void;
}
const isLeumit = detectHmo() === HMO.LEUMIT;
const InstractionsScreen: FC<StepProps> = ({ handleUpdateStep }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const testType = useAppSelector(getTestTypeValue);
  const testTypeLocaleKey = getTestTypeLocaleKey(testType);
  const [youTubeOptions, setYouTubeOptions] = useState();
  const useStyles = makeStyles()(() => styles(theme));
  const { classes } = useStyles();

  useEffect(() => {
    const container = document.getElementById("instractionsScreenContainer");
    if (!container) {
      return;
    }
    const youTubePlayerWidth = container.clientWidth;
    const options: any = {
      height: 216,
      width: youTubePlayerWidth,
    };
    setYouTubeOptions(options);
  }, []);

  const onReady = (event: any) => {
    event.target.pauseVideo();
  };
  const onVideoPlayedHandler = (event: any) => {
    event.target.playVideo();
    sentryLogMessage({
      message: 'InstractionsScreen video played',
      level: 'info',
      tags: {
        component: 'InstractionsScreen',
        category: 'video_played',
        event_type: SENTRY_EVENT_TYPES.VIEWED_TUTORIAL_VIDEO,
      },
      extra: {
        videoId: t(`${testTypeLocaleKey}:InstractionsScreen:youtubeVideo`),
        timestamp: new Date().toISOString(),
      },
    });
  };
  const handleSubmit = () => {
    handleUpdateStep(2);
  };

  return (
    <div id="instractionsScreenContainer" className={classes.container}>
      <div className={classes.bodyContainer}>
        <div className={classes.content}>
          <article className={classes.detailsArticle}>
            <div className={classes.detailsTitle}>{t(`${testTypeLocaleKey}:InstractionsScreen:detailsTitle`)}</div>
            <div>&#9679; {t(`${testTypeLocaleKey}:InstractionsScreen:case1`)}</div>
            <div>&#9679; {t(`${testTypeLocaleKey}:InstractionsScreen:case2`)}</div>
            <div>&#9679; {t(`${testTypeLocaleKey}:InstractionsScreen:case3`)}</div>
            <div>&#9679; {t(`${testTypeLocaleKey}:InstractionsScreen:case4`)}</div>
          </article>
          <article className={classes.detailsArticle}>
            <div className={classes.detailsTitle}>{t(`${testTypeLocaleKey}:InstractionsScreen:detailsTitle2`)}</div>
            <div>&#9679; {t(`${testTypeLocaleKey}:InstractionsScreen:case12`)}</div>
            <div>&#9679; {t(`${testTypeLocaleKey}:InstractionsScreen:case22`)}</div>
          </article>
        </div>
         <div
            className={classNames(
              classes.descriptionBoxContainer,
              classes.descriptionBoxContainerLeumit
            )}
            data-test-id="header-description-box"
          >
              <AttentionIcon
                className={classes.descriptionBoxAlertIcon}
                aria-hidden
              />
            <span className={classes.descriptionBoxAlertText}>
              {t(`${testTypeLocaleKey}:InstractionsScreen:attentionDescription`)}
            </span>
        </div>
        <div className={classes.youTubeContainer}>
          {youTubeOptions ? (
            <YouTube
              iframeClassName={classes.iframeClassName}
              videoId={t(`${testTypeLocaleKey}:InstractionsScreen:youtubeVideo`)}
              opts={youTubeOptions}
              onReady={onReady}
              onPlay={onVideoPlayedHandler}
            />
          ) : null}
        </div>
      </div>

      <MDButton
        style={{ width: theme.width.full, height: theme.spacing.spacing28 }}
        color={"primary"}
        variant="contained"
        type="submit"
        onClick={handleSubmit}
      >
        {t(`${testTypeLocaleKey}:InstractionsScreen:nextButton`)}
      </MDButton>
    </div>
  );
};

export default InstractionsScreen;
